import { PrevStepButton, CloseModalButton } from '@common/components/BookingForms';
import { getDetailRoute } from '@features/rates/helpers/bookingRoutes.helper';
import { Dispatch, SetStateAction } from 'react';
import { useRouter } from 'shared-routing';
import { DisplayCurrentStep } from '../../FormSteps/DisplayCurrentStep';
import { useHashNavigation } from '../../FormSteps/hooks/useHashNavigation';
import { setCurrentStepByHash } from '../../helpers/setCurrentStepByHash';
import { FormStep, StepType, StepTypeWithIndex } from '../../types';

export const StepNavigator = (
  rateCode: string,
  currentStep: StepTypeWithIndex,
  setCurrentStep: Dispatch<SetStateAction<StepTypeWithIndex>>,
  steps: StepType[],
  allFormSteps: FormStep[]
) => {
  const router = useRouter();
  useHashNavigation({
    hash: currentStep.type,
    onNavigate: (hash: string) =>
      setCurrentStepByHash(hash, allFormSteps, (step) => setCurrentStep(step)),
  });

  const goToPreviousStep = () => {
    if (currentStep.type === 'rooms' && currentStep.step === 'guestDetailsStep') {
      return router.push({
        pathname: getDetailRoute(router.pathname),
        query: { id: rateCode, bookingStep: '' },
      });
    }

    return setCurrentStep((val) => {
      const prev = allFormSteps[val.index - 1];
      return prev
        ? { type: prev.type as StepType, index: val.index - 1, step: prev.step }
        : {
            type: 'rooms',
            index: 0,
            step: 'rooms',
          };
    });
  };

  return (
    <>
      <PrevStepButton onClick={goToPreviousStep} />
      <DisplayCurrentStep steps={steps} currentStep={currentStep.type} />
      <CloseModalButton
        onClick={() =>
          router.push({
            pathname: getDetailRoute(router.pathname),
            query: { id: rateCode, bookingStep: '' },
          })
        }
      />
    </>
  );
};
